import axios, { AxiosResponse } from 'axios';
import * as utils from './apiUtils';
import { AdminGroup1IndexResponse } from '@/models/apis/group1/adminGroup1Response';

export default {
  adminIndex(): Promise<AxiosResponse<AdminGroup1IndexResponse>> {
    return axios.get(utils.getApiUrl('/admin/groups1'));
  },
};
